import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PASS_THROUGH } from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as uiActionRendering from './ui-action-rendering'

export const DOC = gql`
  ${uiActionRendering.DOC}
  fragment FragmentMosaicActionExecutionResult on MosaicActionExecutionResult {
    alias
    id
    executedInUi {
      ...FragmentMosaicUiActionRendering
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicActionExecutionResultFragment,
  ents.core.mosaic.Action.ExecutionResult
>({
  alias: graphql.transformers.OUT.validate(
    PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  executedInUi: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(uiActionRendering.TRANSFORMER, {
      onNullish: 'remove',
    }),
    [],
  ),
  id: graphql.transformers.OUT.validate(
    PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
})
